export default __webpack_public_path__ + "static/media/ContactJumbo.43927c6f.png";